import { render, staticRenderFns } from "./CobranzaEdit.vue?vue&type=template&id=92c8ad0a&"
import script from "./CobranzaEdit.vue?vue&type=script&lang=js&"
export * from "./CobranzaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QTabs,QTab,QBadge,QSpace,QBtn,QSeparator,QTabPanels,QTabPanel,QForm,QInput,QCardActions,QInnerLoading,QSpinner,QList,QItem,QItemSection,QItemLabel,QIcon,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QTabs,QTab,QBadge,QSpace,QBtn,QSeparator,QTabPanels,QTabPanel,QForm,QInput,QCardActions,QInnerLoading,QSpinner,QList,QItem,QItemSection,QItemLabel,QIcon})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
